import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { SvgAvatarModule } from 'shared/components/svg-avatar';
import { WorkItemGenesysChatListComponent } from './workitem-genesys-chat-list.component';
import { WorkitemGenesysChatListItemComponent } from './workitem-genesys-chat-list-item/workitem-genesys-chat-list-item.component';
import { WorkItemInteractionModule } from '../shared/workitem-interaction/work-item-interaction.module';
import { GenesysContactDisplayNameModule } from 'shared/components/genesys-contact-display-name/genesys-contact-display-name.module';
import { WorkitemActivityIndicatorModule } from 'shared/components/workitem-activity-indicator/workitem-activity-indicator.module';
import { FormatSecondsModule } from 'shared/pipes/format-seconds/format-seconds.pipe.module';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgAvatarModule,
    SvgIconModule,
    WorkItemInteractionModule,
    GenesysContactDisplayNameModule,
    WorkitemActivityIndicatorModule,
    FormatSecondsModule,
    CustomPipesModule
  ],
  declarations: [
    WorkItemGenesysChatListComponent,
    WorkitemGenesysChatListItemComponent
  ],
  exports: [
    WorkItemGenesysChatListComponent
  ]
})
export class WorkItemGenesysChatListModule {
}
